<div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" appPermissionControl="P114F0001">
    <div class="card-header">
      <div class="title-section">
        <h5 class="header-title">{{ isEdit ? 'Editar' : 'Nueva' }} Persona</h5>
        <div class="client-info" *ngIf="isEdit">
          <p><strong> No. Cliente:</strong> {{ form.get('numero_cliente')?.value }}</p>
          <p><strong> No. Radicado:</strong> {{ form.get('no_radicado')?.value }}</p>
          <p>
            <strong> Nombre Completo:</strong> {{ form.get('primer_nombre')?.value }} {{ form.get('segundo_nombre')?.value }} {{ form.get('apellido_paterno')?.value }}
            {{ form.get('apellido_materno')?.value }}
          </p>
        </div>
      </div>
      <div class="button-section">
        <button mat-flat-button [disabled]="!form.valid" class="btn-success" type="submit" appPermissionControl="P114B0001">
          <mat-icon>save</mat-icon>
          Guardar
        </button>
        <button *ngIf="isEdit" mat-flat-button class="btn-search" type="button" (click)="customizables()" appPermissionControl="P114B0002">
          <mat-icon>settings</mat-icon>
          Customizables
        </button>
        <button mat-flat-button class="btn-delete" type="button" (click)="close()" appPermissionControl="P114B0003">
          <mat-icon>close</mat-icon>
          Cerrar
        </button>
      </div>
    </div>
    <div class="form-row mt-3">
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="numero_cliente" maxlength="50" [disabled]="isEdit" appPermissionControl="P114K0001" />
        <label>No. Cliente</label>
      </div>

      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="antiguedad" appPermissionControl="P114K0002" />
        <label>Antigüedad</label>
      </div>
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="no_radicado" appPermissionControl="P114K0003" />
        <label>No. Radicado</label>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="primer_nombre" appPermissionControl="P114K0004" />
        <label>Primer Nombre</label>
      </div>
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="segundo_nombre" appPermissionControl="P114K0005" />
        <label>Segundo Nombre</label>
      </div>

      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="apellido_paterno" appPermissionControl="P114K0006" />
        <label>Apellido Paterno</label>
      </div>
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="apellido_materno" appPermissionControl="P114K0007" />
        <label>Apellido Materno</label>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field flex-grow-1">
        <input type="date" class="form-control" formControlName="fecha_creacion" disabled [value]="form.get('fecha_creacion')?.value" appPermissionControl="P114K0008" />
        <label>Fecha Creación</label>
      </div>
      <div class="form-field flex-grow-1">
        <input type="email" class="form-control" formControlName="correo_electronico" appPermissionControl="P114K0009" />
        <label>Correo Electrónico</label>
      </div>
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="direccion" appPermissionControl="P114K0010" />
        <label>Dirección</label>
      </div>
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="barrio" appPermissionControl="P114K0011" />
        <label>Barrio</label>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field flex-grow-1 mt-1">
        <p-dropdown
          formControlName="departamento"
          [options]="departamentos"
          optionLabel="nombre"
          optionValue="id"
          [filter]="true"
          [showClear]="true"
          appendTo="body"
          placeholder="-- Seleccione --"
          [loading]="loading"
          appPermissionControl="P114K0012"
        >
          <ng-template let-item pTemplate="item">
            <div class="dropdown-item">{{ item.nombre }}</div>
          </ng-template>
        </p-dropdown>
        <label>Departamento</label>
      </div>

      <div class="form-field flex-grow-1 mt-1">
        <p-dropdown
          formControlName="ciudad"
          [options]="ciudades"
          optionLabel="nombre"
          optionValue="id"
          appendTo="body"
          [filter]="true"
          [showClear]="true"
          [disabled]="!form.get('departamento')?.value"
          placeholder="-- Seleccione --"
          [loading]="loading"
          appPermissionControl="P114K0013"
        >
          <ng-template let-item pTemplate="item">
            <div class="dropdown-item">{{ item.nombre }}</div>
          </ng-template>
        </p-dropdown>
        <label>Ciudad</label>
      </div>
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="codigo_postal" appPermissionControl="P114K0014" />
        <label>Código Postal</label>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="tipo_identificacion" appPermissionControl="P114K0015" />
        <label>Tipo Identificación</label>
      </div>
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="cedula" appPermissionControl="P114K0016" />
        <label>Cédula</label>
      </div>
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="telefono_fijo" appPermissionControl="P114K0017" />
        <label>Teléfono Fijo</label>
      </div>
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="celular" appPermissionControl="P114K0018" />
        <label>Celular</label>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="motivo_reporte" appPermissionControl="P114K0019" />
        <label>Motivo Reporte</label>
      </div>

      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="compania" appPermissionControl="P114K0020" />
        <label>Compañía</label>
      </div>
    </div>
  </form>
</div>

<style>
  .form-control.ng-invalid.ng-touched {
    border-color: #dc3545;
  }

  .form-control.ng-invalid.ng-touched + label {
    color: #dc3545;
  }

  .text-danger {
    font-size: 0.75rem;
    margin-top: 0.25rem;
  }

  /* Estilos para los dropdowns de PrimeNG */
  :host ::ng-deep .p-dropdown {
    width: 100%;
    border-radius: 0.3rem;
  }

  :host ::ng-deep .p-dropdown-panel {
    font-size: 0.875rem;
  }

  :host ::ng-deep .p-dropdown-items {
    padding: 0;
  }

  :host ::ng-deep .p-dropdown-filter {
    padding: 0.5rem;
  }

  :host ::ng-deep .p-dropdown-item {
    padding: 0.5rem;
  }
</style>
